const generateLastExpDate = ({ documentList, field }) => {
  const lastExpDate = documentList?.findLast(
    doc => doc?.document === field,
  )?.exp_date;

  return lastExpDate || '';
};

export default generateLastExpDate;
